import type { ControlFormProps } from '@ingenico/react-section-utils';
import { useUpdateEffect } from '@react-hookz/web';
import type { FieldPath } from 'react-hook-form';
import { useController } from 'react-hook-form';
import type { SystemPackageAppVersion } from '../pages/create-system-package-version-page/createSystemPackageVersionPage.model';

export function useHandleCleanBuildStepField(
  formControl: ControlFormProps<SystemPackageAppVersion>['control'],
  fieldToTrack: FieldPath<SystemPackageAppVersion>,
  fieldToReset: FieldPath<SystemPackageAppVersion>,
): void {
  const {
    field: { onChange: setFieldValue, value: fieldToResetValue },
  } = useController({ control: formControl, name: fieldToReset });

  const {
    field: { value: trackedFiedValue },
  } = useController({ control: formControl, name: fieldToTrack });

  useUpdateEffect(() => {
    if (fieldToResetValue) {
      setFieldValue(undefined);
    }
  }, [trackedFiedValue]);
}
